import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert2
import { jwtDecode } from "jwt-decode";

import { useNavigate } from "react-router-dom";

const Register = () => {
  // State variables to hold form data
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("user"); // Default role can be 'user'
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create the user data object
    const userData = {
      username,
      password,
      email,
      role,
    };

    try {
      // Sending POST request to the backend
      const response = await axios.post(
        `${API_URL}/api/regauth/register`,
        userData,
      );

      // If registration is successful
      if (response.data.message === "User registered successfully") {
        Swal.fire({
          title: "Success!",
          text: "User registered successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      // Handle errors
      if (error.response && error.response.data) {
        Swal.fire({
          title: "Error!",
          text: error.response.data.error,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "An error occurred, please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded?.role;

        if (role !== "admin") {
          // Not allowed, redirect to dashboard
          navigate("/dashboard");
        }
      } catch (err) {
        console.error("Invalid token:", err);
        navigate("/dashboard"); // Redirect if token is invalid
      }
    } else {
      navigate("/dashboard"); // Redirect if no token found
    }
  }, [navigate, token]);

  // Handle form reset
  const handleClear = () => {
    setUsername("");
    setPassword("");
    setEmail("");
    setRole("admin");
  };

  return (
    <div className="container mt-5">
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label htmlFor="username" className="text-dark">
            Username
          </label>
          <input
            type="text"
            className="form-control"
            id="username"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="password" className="text-dark">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="email" className="text-dark">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group mb-4">
          <label htmlFor="role" className="text-dark">
            Role
          </label>
          <select
            className="form-control"
            id="role"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="admin">Admin</option>
            <option value="manager">Manager</option>
            <option value="Csd">Csd</option>
            <option value="Branding">Branding</option>
            <option value="user">User</option>
          </select>
        </div>

        {/* Submit Button with regular size */}
        <div className="d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            Register
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </form>
    </div>
  );
};

export default Register;
